import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DataTypeContext } from '../DataTypes';

export const useCustomTranslator = () => {
  const { t } = useTranslation();
  const { dataTypes } = useContext(DataTypeContext);
  
  const customT = (key, options) => {
    if (dataTypes?.errorMessages && 
        dataTypes.errorMessages[key] && 
        typeof dataTypes.errorMessages[key] === 'string' && 
        dataTypes.errorMessages[key].trim() !== '') {
      return dataTypes.errorMessages[key];
    }
    
    return t(key, options);
  };
  
  return customT;
};